import { render, staticRenderFns } from "./relation.html?vue&type=template&id=09f21679&"
import script from "./relation.ts?vue&type=script&lang=ts&"
export * from "./relation.ts?vue&type=script&lang=ts&"
import style0 from "./relation.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports